<template>
  <div id="footer">
      <!-- <div class="guide" v-if="notEnglish" style="background-image: url(https://album.usho.cn/www/upload/9f9b7f7fff9bf596f91879e9e2c38c18.png?imageView2/1/w/1200/h/180/q/10);">
          <p class="text">离开学校，进入社汇</p>
          <div class="button-box">
            <div class="free-use"  @click="dialogClick('留言信息')">获取方案</div>
            <div class="contact-us" @click="$router.push('/about/contact')">联系我们</div>
          </div>
      </div>      -->
      <div class="info">
          <!-- <div class="us-info">
            <img class="logo" src="https://pics.usho.cn/20240913/1726220353.png" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
            <div class="item">
              <img class="item-icon" src="https://album.usho.cn/www/upload/92bfd03f8fffe839926a3a5cfd026791.png?imageView2/1/q/40" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
              <span class="item-text">0571-86711325</span>
            </div>
            <div class="item">
              <img class="item-icon" src="https://album.usho.cn/www/upload/fba004343535ddf2d8f7c368939b1687.png?imageView2/1/q/40" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
              <span class="item-text">杭州市西湖区申花路798号紫金港创新企业园-1106室 友笑网络</span>
            </div>
            <p>Copyright © 2015-2022 友笑网络 版权所有  </p>
          </div>
          <div class="service">
              <div class="service-item" @click="$router.push('/product')">产品</div>
             
              <div class="service-item" @click="$router.push('/about')">关于我们</div>
               <div class="service-item" @click="$router.push('/media')">新媒体</div>
              <div class="service-item" @click="$router.push('/partner')">伙伴案例</div>
             
             
               <div class="service-item" @click="$router.push('/about/history')">友笑历程</div>
               <div class="service-item" @click="$router.push('/about/contact')">联系我们</div>
              <div class="service-item" @click="$router.push('/english')">English</div>
              <div class="service-item" @click="$router.push('/about/join')">加入我们</div>
          </div>
          <div class="code-box">
            <div class="code">
              <div class="code-icon-box">
                  <img class="code-icon" src="https://album.usho.cn/www/upload/431944bd8fefb504e9472584547f0a07.png?imageView2/1/q/40" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
              </div>
              <p class="code-name">社汇小程序</p>
            </div>
            <div class="code">
              <div class="code-icon-box">
                  <img class="code-icon" src="https://album.usho.cn/www/upload/fa9ad51bb0b6656d1965b904c621a1e4.png?imageView2/1/q/40" alt="校友、校友会、校友会系统（软件）、校友系统（软件）、校友企业（软件）、校友经济、知名校友、校友相册">
              </div>
              <p class="code-name">社汇公众号</p>
            </div>
          </div>  -->
          <a class="beian" href="https://beian.miit.gov.cn/" target="_blank">
            
              {{icp}}
          
          </a >            
      </div> 
      <vServicechat ref="child" v-if="showdialog" />
  </div>
</template>

<script>
import vServicechat from '@/components/v-servicechat';
export default {
  components:{
    vServicechat,
  },
  data () {
    return {
       showdialog:false,
       icp:"浙ICP备12021015号-2"
    }
  },
  created(){
    if(window.location.host == "www.sosho.cn"){
      this.icp = "浙ICP备12021015号-2";
    }else{
      this.icp = "浙ICP备12021015号-3";
    }   
  },
  computed:{
    notEnglish(){
      return this.$route.path !== '/english'
    }
  },
  methods:{
    dialogClick(title){
      this.showdialog = true;
      this.$nextTick(() => {
        this.$refs.child.xcxClick(title);
      })
    },
  }
}
</script>

<style lang="less"  scoped>

#footer{
    width: 100%;
    overflow: hidden; 
    .guide{
      height: 280px;
      width: 100%;
     // background-image: url(https://album.usho.cn/www/upload/9f9b7f7fff9bf596f91879e9e2c38c18.png?imageView2/1/w/1200/h/180/q/10);
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
      overflow: hidden; 
    }   
}
//  .guide{
//    height: 280px;
//    width: 100%;
//    background:rgba(186, 237, 240, 0.43);
//    overflow: hidden; 
//  }
.text{
  font-size: 36px;
  
  font-weight: 500;
  color: #FFFFFF;
  margin-top:75px;
  text-align: center;
}
.button-box{
  width: 392px;
  margin:0 auto;
  margin-top:32px;
}
.free-use{
  width: 184px;
  height: 56px;
  background: #31CEC2;
  box-shadow: 0px 5px 15px 0px rgba(54, 183, 174, 0.64);
  border-radius: 8px;
  text-align: center;
  line-height: 56px;
  font-size: 20px;
  
  font-weight: 500;
  color: #FFFFFF;
  float: left;
  cursor: pointer;
}
.contact-us{
  width: 184px;
  height: 56px;
  border-radius: 8px;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  line-height: 56px;
  text-align: center;
  font-size: 20px;
  
  font-weight: 500;
  color: #FFFFFF;
  cursor: pointer;
  float: right;
}
.info{
  width: 1200px;
  // height: 405px;
  // height: 377px;
  margin:0 auto;
  line-height: 80px;
  // padding-top:120px;
  box-sizing: border-box;
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
}
.us-info{
  float: left;
  width: 600px;
}
.logo{
  width: 139px;
  height: 36px;
  display: block;
  margin-bottom: 37px;
}
.item{
  margin-bottom: 10px;
}
.item-icon{
  width: 26px;
  height: 26px;
  display: inline-block;
}
.item-text{
  margin-left: 11px;
  display: inline-block;
  vertical-align: 5px;
}
.service{
  float: left;
  width: 220px;
  // height: 200px;
}
.service-item{
  display: inline-block;
  width: 80px;
  height: 40px;
  // vertical-align: top;
  cursor: pointer;
}
.code-box{
  float: right; 
}
.code{
  width: 112px;
  display: inline-block;
  margin-left: 16px;
}
.code-icon-box{
  width: 112px;
  height: 112px;
}
.code-icon{
  height: 100%;
  width: 100%;
}
.code-name{
  font-size: 14px;
  
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  margin-top:12px;
  text-align: center;
}
.beian{
  
  font-weight: 400;
  color: rgba(0, 0, 0, 0.45);
  display: block;
  margin:0 auto;
  text-align: center;
  clear: both;
  padding-top:50px;
}
</style>



// WEBPACK FOOTER //
// src/components/v-footer.vue